import React from 'react'
import Footer from '../Components/Footer/Footer'
import LoginTopBar from '../Components/LoginTopBar/LoginTopBar'
import DriverLogin from '../DriverComponents/DriverLogin/DriverLogin'

const DriverLoginPage = () => {
  return (
    <>
    <LoginTopBar/>
    <DriverLogin/>
    {/* <Footer/> */}
    
    </>
  )
}

export default DriverLoginPage